export const showAlert = (message, type = 'success', duration = 5000) => {
  const alertDiv = document.createElement('div');
  alertDiv.setAttribute('role', 'alert');
  alertDiv.className = `${type}-message`;
  alertDiv.textContent = message;
  document.body.appendChild(alertDiv);
  setTimeout(() => alertDiv.remove(), duration);
};

export const showConfirmDialog = (message) => {
  return window.confirm(message);
};